import { apiClient } from "./ApiConfig"
import Helpers from "@utils/Helpers"

export const conversationApi = {
    sendMessage: (body: any) => {
        return apiClient.post('/conversation/send-message-with-email', body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getConversattion: () => {
        return apiClient.get('/conversation');
    },
    getConversationMessages: (conversationId: number) => {
        return apiClient.get(`/conversation/${conversationId}`);
    },
    markViewed: (body: any) => {
        return apiClient.post(`/conversation/mark-viewed`, body);
    },
    pinConversation: (body: { conversation_id: number }) => {
        return apiClient.post('/conversation/pin', body)
    },
    countUnviewed: () => {
        return apiClient.get('/conversation/count-unviewed')
    },
    deleteAllConversations: (customToken?: string) => {
        const token = customToken || Helpers.getAccessToken();
        const headers: Record<string, string> = {};
        if (token) {
            headers["Authorization"] =
                token.startsWith("BEARER ") || token.startsWith("Bearer ")
                    ? token
                    : `BEARER ${token}`;
        }
        return apiClient.delete('/conversation/delete-all', {
            headers,
        });
    }
}
